import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { type FC } from "react";

import { PercentageComponent } from "~/components/UI/PercentageComponent";
import { RichTooltip } from "~/components/UI/RichTooltip";
import { formatNumber } from "~/utils/formatValue";

import * as Styled from "./MetricCard.styles";

interface IMetricCardProps {
  title: string;
  value: number | string | null | undefined;
  percentage?: number | null;
  showInfo?: boolean;
  infoText?: string;
  className?: string;
}

export const MetricCard: FC<IMetricCardProps> = ({
  title,
  value,
  percentage,
  showInfo = false,
  infoText,
  className,
}) => {
  const formattedValue =
    typeof value === "string"
      ? value
      : value == null
        ? "N/A"
        : formatNumber(value);

  return (
    <Styled.MetricCard className={className} elevation={0}>
      {showInfo && infoText && (
        <Styled.CardHeader>
          <RichTooltip title={infoText}>
            <InfoOutlinedIcon fontSize="small" color="disabled" />
          </RichTooltip>
        </Styled.CardHeader>
      )}
      <Styled.CardContent>
        <Styled.Title variant="caption" color="text.secondary">
          {title}
        </Styled.Title>
        <Styled.ValueContainer
          direction="row"
          spacing={1}
          sx={{ alignItems: "baseline" }}
        >
          <Styled.Value variant="caption" sx={{ fontWeight: 700 }}>
            {formattedValue}
          </Styled.Value>
          <PercentageComponent percentage={percentage} isBold={true} />
        </Styled.ValueContainer>
      </Styled.CardContent>
    </Styled.MetricCard>
  );
};
